export const getBannerContainerStyles = (isMobile: boolean) =>
   `fixed bottom-0 flex items-center w-full z-[50] ${
      isMobile ? 'px-[16px] py-[8px] z-[50]' : 'px-[24px] py-[12px]'
   }`

export const bannerTextContainerStyles = (isMobile: boolean) =>
   `justify-center items-center gap-2 flex-1 ${
      isMobile ? 'flex flex-col' : 'flex flex-row'
   }`
export const bannerTextStyles = 'flex justify-center items-center gap-3'

export const getBannerTextStyles = (isMobile: boolean) =>
   isMobile ? 'text-xs-semibold' : 'text-md-semibold'

export const iconContainerStyles = 'w-content'
